import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type {
  PostConversationalPreviewWorkflowErrors,
  PostConversationalPreviewWorkflowProps,
  PostConversationalPreviewWorkflowResult,
} from "./types";

export const postConversationalPreviewWorkflow = reactQueryMutationAdapter(
  [],
  createMutationFetcherFunctionWithShadowError<PostConversationalPreviewWorkflowErrors>()(
    (props: PostConversationalPreviewWorkflowProps): Promise<PostConversationalPreviewWorkflowResult> => {
      return fetch(`/${props.appGroupId}/conversational/preview_workflow`, "POST", {
        session_id: props.sessionId,
        user_message: props.userMessage,
        user_id: props.userId,
        conversational_workflow_payload: props.conversationalWorkflowPayload,
      });
    }
  )
);
